import urlcat from 'urlcat';
import { CategoryFormData } from '../components/forms/schemas/category';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { axiosInstance } from '../utils/fetcher';

export const categoriesService = {
  getExpenseCategory: async () => {
    const { data } = await axiosInstance.get(API_ENDPOINTS.EXPENSE_CATEGORY);

    return data;
  },

  getIncomeCategory: async () => {
    const { data } = await axiosInstance.get(API_ENDPOINTS.INCOME_CATEGORY);

    return data;
  },

  createCategory: async (category: CategoryFormData) => {
    const {backgroundColor, iconColor, icon, ...categoryData} = category;
    // eslint-disable-next-line no-useless-escape
    const iconName = icon?.includes('http') ? icon.match(/\/([^\/]+?)(?:\.svg)+$/)?.[1] : icon;
    const { data } = await axiosInstance.post(API_ENDPOINTS.CREATE_CATEGORY, {...categoryData, backgroundColor, icon: iconName});

    return data;
  },

  updateCategory: async (categoryId: string, category: CategoryFormData) => {
    const {backgroundColor, icon, ...categoryData} = category;
    // eslint-disable-next-line no-useless-escape
    const iconName = icon?.includes('http') ? icon.match(/\/([^\/]+?)(?:\.svg)+$/)?.[1] : icon;
    const { data } = await axiosInstance.put(urlcat(API_ENDPOINTS.UPDATE_CATEGORY, { id: categoryId }), {...categoryData, icon: iconName, iconColor: backgroundColor});

    return data;
  },

  createCategoryGroup: async (category: any) => {
    let {backgroundColor, categories, icon, ...categoryData} = category;
    // eslint-disable-next-line no-useless-escape
    const iconName = icon?.includes('http') ? icon.match(/\/([^\/]+?)(?:\.svg)+$/)?.[1] : icon;
    // eslint-disable-next-line no-useless-escape
    categories = categories.map((c: any) => ({...c, icon: c.icon?.includes('http') ? c.icon.match(/\/([^\/]+?)(?:\.svg)+$/)?.[1] : c.icon}))
    const { data } = await axiosInstance.post(API_ENDPOINTS.CREATE_CATEGORY_GROUP, {...categoryData, icon: iconName, categories});

    return data;
  },

  updateCategoryGroup: async (categoryId: string, category: CategoryFormData) => {
    const endpoint = urlcat(API_ENDPOINTS.UPDATE_CATEGORY_GROUP, { id: categoryId });
    const {icon, ...categoryData} = category;
    // eslint-disable-next-line no-useless-escape
    const iconName = icon?.includes('http') ? icon.match(/\/([^\/]+?)(?:\.svg)+$/)?.[1] : icon;
    const { data } = await axiosInstance.put(endpoint, {...categoryData, icon: iconName});

    return data;
  },
};